<template>
<div class='depthmap' :style="'width:'+width+'px;'">
      <canvas style="display:none;" :width = "width" :height = "height" ref = "canRef"></canvas>
      <canvas :width = "width" :height = "height" ref = "canRef2"></canvas>
      </div>
</template>

<script>


export default {
  name: "Documents",
  components: {
  
  },
  props:{
    doScan:{defalut:true},
    imagePath:{default:'depthMapEmpty.png'},
  },
  data() {
    return {
     canvas: null,
      canvas2: null,
            ctx: null,
            ctx2: null,
            img: null,
            src: null,
            lineY:10,
            metal:0
    };
  },
  mounted(){
   this.canvasImage()
  },
  computed:{
    width(){
      return 538
     
    },
    height(){
      return 470
     
    }
  },
  methods:{
    canvasImage(){
      let self = this
      self.canvas = self.$refs.canRef
      self.canvas2 = self.$refs.canRef2
      self.ctx = self.canvas.getContext ('2d')
      self.ctx2 = self.canvas2.getContext ('2d')
      // Add self.img before src and move after new Image ()
      self.img = new Image ()
      self.img.src = require('@/assets/images/maps/'+this.imagePath)
      self.img.onload = function () {
          console.log ('loaded')
          // No error occurs by assigning this to self
          self.ctx.drawImage (self.img, 0, 0,self.width,self.height);
          //self.showCrossSection()
      }
    },
    loadNewImage(){
      let self = this
      self.img = new Image ()
      self.img.src = require('@/assets/images/maps/'+self.imagePath)
      self.img.onload = function () {
          console.log ('loaded')
          // No error occurs by assigning this to self
          self.ctx.drawImage (self.img, 0, 0,self.width,self.height);
          self.lineY=4
          //self.showCrossSection()
      }
    },
    showCrossSection(){
      var scrollSpeed=6
      var pixelData 
      var drawPos=120

      var imageData = this.ctx2.getImageData(0, 0, this.ctx2.canvas.width, this.ctx2.canvas.height);
      this.ctx2.putImageData(imageData, 0, scrollSpeed);
      this.ctx2.beginPath();
      for(var i=0; i<this.width;i++){
        pixelData = this.ctx.getImageData(i, this.height-this.lineY, 1, 1).data; 
        if(i==0){
           this.ctx2.moveTo(i, drawPos-pixelData[0]/2-this.lineY*0);
        }else{
          this.ctx2.lineTo(i, drawPos-pixelData[0]/2-this.lineY*0);
          this.metal=pixelData[1]/255*100
          //250 - 60
          if(this.metal>50){
            this.ctx2.strokeStyle = 'hsl('+ (150-pixelData[0]/255*50-this.metal) +','+2*50+'%,50%)';
          }else{
            this.ctx2.strokeStyle = 'hsl('+ (pixelData[0]/255*190+60+this.metal) +','+2*50+'%,50%)';
          }
          
          //this.ctx2.strokeStyle = 'hsl('+ (pixelData[0]/250*360) +',100%,50%)';
          this.ctx2.stroke();
          this.ctx2.beginPath();
          this.ctx2.moveTo(i, drawPos-pixelData[0]/2-this.lineY*0);
        }
          
      }
      
      //this.ctx2.strokeStyle = "#00FFFF";
      //this.ctx2.stroke();
      if(this.doScan){
        this.continueScan()
      }
      
    },
    continueScan(){
      if(this.lineY<this.height-5){
          this.lineY+=4;
          setTimeout(this.showCrossSection,100)
        }else{
          this.lineY=4
          setTimeout(this.showCrossSection,100)
        }
    }
  },
  watch:{
    imagePath(){
      this.loadNewImage()
    },
    doScan(val){
      if(val){
        this.continueScan()
      }
    }
  }
}
</script>

<style>
.depthmap {
  position:relative;
  width: 800px;

}

</style>